module.exports = __webpack_public_path__ + "static/media/heroes_home.caa337f5.svg";